/** PDF/email entry uses ?code=; API body field is claim_code. */
export function mapQueryCodeToClaimCode(code: string | null | undefined): string | undefined {
  const trimmed = code?.trim();
  return trimmed ? trimmed : undefined;
}
